import React from 'react';

import ModalOuterContainer from '../../generic/containers/ModalOuterContainer';
import Button from 'components/shared/generic/button/presentational/Button';
import Typography from 'components/shared/generic/typography/presentational/Typography';
import useTranslate from 'lib/languages/useTranslate';
import { formatMoney } from 'lib/utils';
import { useGetFeesQuery } from 'lib/services/fees';

interface LSDStatusCardModalProps {
    handleSubmit: () => void;
    handleClose: () => void;
}

const LSDStatusCardModal: React.FC<LSDStatusCardModalProps> = ({
    handleSubmit,
    handleClose,
}) => {
    const translate = useTranslate('cards.orderReplacementModal');
    const { data: allFees } = useGetFeesQuery();

    return (
        <ModalOuterContainer customButtons={true}>
            <div className="description">
                <Typography tag="h1">{translate('titleText')}</Typography>
                <Typography styles={{ marginBottom: '8px' }}>
                    {translate('feeWarning', {
                        fee: formatMoney(allFees?.replacementCard),
                    })}
                </Typography>
            </div>
            <div className="button-container">
                <Button className="cancel" onClick={handleClose}>
                    {translate('cancel')}
                </Button>
                <Button onClick={handleSubmit}>
                    {translate('submitText')}
                </Button>
            </div>
        </ModalOuterContainer>
    );
};

export default LSDStatusCardModal;
